/** @format */

import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import SkeletonPaymentContributionCard from "../skeleton/SkeletonPaymentContributionCard";
import { CardWrapper } from "./styles";
import { formatCurrency } from "../../../utility/currencyUtils";
import {
	Avatar,
	Box,
	Grid,
	// Menu,
	// MenuItem,
	Typography,
} from "@mui/material";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import GetAppTwoToneIcon from "@mui/icons-material/GetAppOutlined";
// import FileCopyTwoToneIcon from "@mui/icons-material/FileCopyOutlined";
// import PictureAsPdfTwoToneIcon from "@mui/icons-material/PictureAsPdfOutlined";
// import ArchiveTwoToneIcon from "@mui/icons-material/ArchiveOutlined";
import { colors } from "../../../utility/types/constant";

interface PaymentContributionCardProps {
	isLoading: boolean;
	totalContributionHistory: number;
	currency?: string;
}

const PaymentContributionCard = (props: PaymentContributionCardProps) => {
	const { isLoading, totalContributionHistory, currency = "usd" } = props;

	const theme = useTheme();

	// const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	// const handleClick = (event: React.MouseEvent<HTMLElement>) => {
	//   setAnchorEl(event.currentTarget);
	// };

	// const handleClose = () => {
	//   setAnchorEl(null);
	// };

	return (
		<>
			{isLoading ? (
				<SkeletonPaymentContributionCard />
			) : (
				<CardWrapper border={false} content={false}>
					<Box sx={{ p: 2.25 }}>
						<Grid container direction="column">
							<Grid item>
								<Grid container justifyContent="space-between">
									<Grid item>
										<Avatar
											variant="rounded"
											sx={{
												...theme.typography,
												...theme.typography,
												backgroundColor: colors.mainSecondary,
												mt: 1,
											}}>
											<img
												src="/assets/icons/payment-icon.png"
												alt="earning icon"
											/>
										</Avatar>
									</Grid>

									{/* <Grid item>
                    <Avatar
                      variant="rounded"
                      sx={{
                        ...theme.typography,
                        ...theme.typography,
                        backgroundColor: colors.mainSecondary,
                        color: (theme.palette.secondary as any)[200],
                        zIndex: 1,
                      }}
                      aria-controls="menu-earning-card"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <MoreHorizIcon fontSize="inherit" />
                    </Avatar>

                    <Menu
                      id="menu-earning-card"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      variant="selectedMenu"
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <MenuItem onClick={handleClose}>
                        <GetAppTwoToneIcon sx={{ mr: 1.75 }} /> Import Card
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <FileCopyTwoToneIcon sx={{ mr: 1.75 }} /> Copy Data
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <PictureAsPdfTwoToneIcon sx={{ mr: 1.75 }} /> Export
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <ArchiveTwoToneIcon sx={{ mr: 1.75 }} /> Archive File
                      </MenuItem>
                    </Menu>
                  </Grid> */}
								</Grid>
							</Grid>

							<Grid item>
								<Grid container alignItems="center">
									<Grid item>
										<Typography
											sx={{
												color: colors.white,
												fontFamily: "'Montserrat', sans-serif",
												fontSize: "2.125rem",
												fontWeight: 900,
												mr: 1,
												mt: 1.75,
												mb: 0.75,
											}}>
											{formatCurrency(totalContributionHistory, currency)}
										</Typography>
									</Grid>

									{/* <Grid item>
                    <Avatar
                      sx={{
                        cursor: "pointer",
                        ...theme.typography,
                        backgroundColor: colors.secondary,
                        color: colors.white,
                      }}
                    >
                      <ArrowUpwardIcon
                        fontSize="inherit"
                        sx={{ transform: "rotate3d(1, 1, 1, 45deg)" }}
                      />
                    </Avatar>
                  </Grid> */}
								</Grid>
							</Grid>

							<Grid item sx={{ mb: 1.25 }}>
								<Typography
									sx={{
										fontSize: "1.5rem",
										fontWeight: 900,
										fontFamily: "'Montserrat', sans-serif",
										color: colors.white,
									}}>
									Total Contribution
								</Typography>
							</Grid>
						</Grid>
					</Box>
				</CardWrapper>
			)}
		</>
	);
};

PaymentContributionCard.propTypes = {
	isLoading: PropTypes.bool,
	totalContributionHistory: PropTypes.number,
};

export default PaymentContributionCard;
